import store from '@/store'
import multiguard from "vue-router-multiguard";
import {loginRequired, needPhoneVerification} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";
import StoreDashboard from "../views/Store/Layout/StoreDashboard";
import TableProduct from "../components/StoreDashboard/Product/TableProduct";
import StoreDashboardTemplate from "../views/Store/Layout/StoreDashboardTemplate";
import CreateStoreProduct from "../components/StoreDashboard/Product/CreateStoreProduct";
import Chats from "../views/dashboard/Chats";
import UserChats from "../views/dashboard/UserChats";
import Statistic from "../views/Statistic.vue";
import LinkToolKit from "../views/dashboard/LinkToolKit.vue";
import Tag from "../views/dashboard/Tag.vue";
import CreateTag from "@/plugin/components/dashboard/Tag/CreateTag.vue";
import UpdateTag from "@/plugin/components/dashboard/Tag/updateTag.vue";
import TrashTag from "@/plugin/components/dashboard/Tag/TrashTag.vue";
import ChatCreate from "@/plugin/components/dashboard/Chat/ChatCreate.vue";
import ProductBasalamSetting from "@/plugin/views/dashboard/ProductBasalamSetting.vue";
import Sms from "@/plugin/views/dashboard/Sms.vue";
import SendSms from "@/plugin/components/dashboard/Sms/SendSms.vue";
import WishList from "@/plugin/views/dashboard/WishList.vue";
import Subscription from "@/plugin/views/dashboard/Subscription.vue";
import UserSubscription from "@/plugin/views/dashboard/UserSubscription.vue";
import CreateForm from "../components/dashboard/Form/CreateForm.vue";
import UpdateForm from "../components/dashboard/Form/UpdateForm.vue";
import FormFills from "../components/dashboard/Form/FormFills.vue";
import FormAnswer from "../components/dashboard/Form/FormAnswer.vue";
import CurrentUserFormFills from "../components/dashboard/Form/CurrentUserFormFills.vue";
import UserFormFills from "../components/dashboard/Form/UserFormFills.vue";
import PrintCourseForm from "../components/dashboard/Form/PrintCourseForm.vue";
import Logs from "@/plugin/views/dashboard/Logs.vue";
import CreateEvent from "../components/dashboard/Event/CreateEvent.vue";
import UpdateEvent from "../components/dashboard/Event/UpdateEvent.vue";
import AllSubscription from "../components/dashboard/AllSubscription/AllSubscription.vue";
import CreatSubscription from "../components/dashboard/AllSubscription/CreatSubscription.vue";
import UpdateSubscription from "../components/dashboard/AllSubscription/UpdateSubscription.vue";
import SubscriptionCharge from "../views/dashboard/SubscriptionCharge.vue";
import SendSmsWithTemplate from "../components/dashboard/Sms/SendSmsWithTemplate.vue";
import SubscriptionChargeFilter from "../views/dashboard/SubscriptionChargeFilter.vue";
import DeliveryPriceBaseOnLocation
    from "../components/dashboard/DeliveryPriceBaseOnLocation/DeliveryPriceBaseOnLocation.vue";
import Share from "../views/dashboard/Share.vue";
import UserCourse from "@/plugin/components/dashboard/Course/UserCourse.vue";
import ModulesList from "@/plugin/views/dashboard/ModulesList.vue";
import ModuleInstall from "@/plugin/views/dashboard/ModuleInstall.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import UserAccessDenied from "@/plugin/views/dashboard/UserAccessDenied.vue";

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Dashboard")
const DashboardTemplate = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/DashboardTemplate")
const Profile = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/auth/Profile")
const Address = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Address")
const CreateAddress = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Address/CreateAddress")
const UpdateAddress = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Address/UpdateAddress")
const Brand = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Brand")
const CreateBrand = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Brand/CreateBrand")
const EditBrand = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Brand/EditBrand")
const TrashBrand = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Brand/Trash")
const Feature = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Feature")
const TrashFeatures = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Feature/Trash")
const CreateFeature = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Feature/Create")
const UpdateFeature = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Feature/Update")
const Category = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Category")
const TrashCategory = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/category/Trash")
const ProductsDashboard = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Products")
const SiteInfo = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/SiteInfo")
const CreateSiteInfo = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/SiteInfo/Create")
const UpdateSiteInfo = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/SiteInfo/Update")
const CreateProduct = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/product/CreateProduct")
const EditProduct = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/product/EditProduct")
const TrashProduct = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/product/trashItems")
const User = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/User")
const TrashUser = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/User/Trash")
const UpdateUser = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/User/Update")
const Offer = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Offer")
const TrashOffer = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Offer/Trash")
const UpdateOffer = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Offer/Update")
const CreateOffer = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Offer/Create")
const Orders = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/orders")
const AllOrders = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/allOrders")
const CoursesDashboard = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Courses")
const CreateCourse = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Course/CreateCourse")
const EditCourse = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Course/EditCourse")
const CourseTrash = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Course/trashitems")
const CreateContent = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Content/CreateContent")
const UpdateContent = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Content/UpdateContent")
const PostsListDashboard = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Posts")
const PagesListDashboard = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Pages")
const TrashContentList = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Content/trashItems")
const Lessons = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Lessons")
const CreateContentLesson = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Content/CreateContentLesson")
const UpdateContentLesson = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Content/UpdateContentLesson")
const FileManager = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/FileManager")
const CreateUser = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/User/Create')
const Menu = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Menu")
const Menus = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Menus")
const Comments = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Comments")
const Timing = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Timing")
const ChangePassword = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/User/ChangePassword")
const AddUserToProduct = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/AddUserToProduct")
const CreateOrder = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/orders/CreateOrder")
const OrderWithoutItem = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/orders/OrderWithoutItem")
const Deliveries = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Deliveries")
const CreateDelivery = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Delivery/CreateDelivery")
const UpdateDelivery = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Delivery/UpdateDelivery")
const ChargeWallet = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Wallet/ChargeWallet")
const LoansAdmin = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/LoansAdmin")
const LoansUser = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/LoansUser")
const LoanItems = () => import(/* webpackChunkName: "dashboard" */ "../components/dashboard/Loan/LoanItems")
const Languages = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Languages");
const MultipleStores = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/MultipleStores");
const Form = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Form.vue");
const Event = () => import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Event.vue");

const generateRandomString = () => {
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
    );
};


/*
*
role    type   access		    description
1	     0	   admin		    access to every thing
2	     1	   store		    access to order and products
1(3)	 1	   editor		    access to all content section such as brand, category, post, product…
1(4)	 2	   author		    only access to post, page
1(5)	 3	   order section	only access to order section
* */

export const dashboardMenu = [
    {
        id: generateRandomString(),
        name: "بازگشت به سایت",
        icon: "house",
        route: {name: "Home"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "داشبورد",
        icon: "bar-chart",
        route: {name: "Dashboard"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "حساب کاربری",
        icon: "person",
        route: {},
        access: [],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "پروفایل",
                icon: "person-fill",
                route: {name: "Profile"},
                access: [],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "آدرس های من",
                icon: "signpost2-fill",
                route: {name: "Address"},
                access: [],
                action: () => {
                },
                children: [],
            },
        ],
    },
    {
        id: generateRandomString(),
        name: "مدیریت فروشگاه",
        icon: "shop",
        route: {},
        access: ['1-0', '2-1', '1-1', '1-2'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "دسته بندی",
                icon: "box-seam",
                module: "category",
                route: {name: "Category"},
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "محصولات",
                icon: "shop-window",
                route: {name: "ProductsDashboard"},
                module: "product",
                access: ['1-0', '2-1', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: 'ویژگی های محصول',
                icon: 'card-checklist',
                route: {name: 'Feature'},
                module: "product_features",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: []
            },
            {
                id: generateRandomString(),
                name: "برندها",
                icon: "gear",
                route: {name: "Brand"},
                module: "brand",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "سفارش ها",
                icon: "calendar-week",
                route: {},
                access: [],
                action: () => {
                },
                children: [
                    {
                        id: generateRandomString(),
                        name: "سفارش های من",
                        icon: "cart-check",
                        route: {name: "UserOrders"},
                        access: [],
                        action: () => {
                        },
                        children: [],
                    },
                    {
                        id: generateRandomString(),
                        name: "همه سفارش ها",
                        icon: "bar-chart",
                        route: {name: "Orders"},
                        module: "order",
                        access: ['1-0', '2-1', '1-3'],
                        action: () => {
                        },
                        children: [],
                    },
                    {
                        id: generateRandomString(),
                        name: "گزارش رزرویشن",
                        icon: "bar-chart",
                        route: {name: "ReservationOrders"},
                        module: "reservation",
                        access: ['1-0', '2-1'],
                        action: () => {
                        },
                        children: [],
                    },
                    {
                        id: generateRandomString(),
                        name: "ثبت سفارش",
                        icon: "bar-chart",
                        route: {name: "CreateOrder"},
                        module: "manual_order",
                        access: ['1-0'],
                        action: () => {
                        },
                        children: [],
                    },
                    {
                        id: generateRandomString(),
                        name: "سفارش سریع",
                        icon: "phone",
                        route: {name: "OrderWithoutItem"},
                        module: "quick_order",
                        access: ['1-0'],
                        action: () => {
                        },
                        children: [],
                    },
                ],
            },
            {
                id: generateRandomString(),
                name: "اقساط",
                icon: "credit-card-fill",
                route: {},
                access: [],
                action: () => {
                },
                children: [
                    {
                        id: generateRandomString(),
                        name: "اقساط من",
                        icon: "credit-card-fill",
                        route: {name: "LoansUser"},
                        access: [],
                        action: () => {
                        },
                        children: [],
                    },
                    {
                        id: generateRandomString(),
                        name: "همه اقساط",
                        icon: "bar-chart",
                        route: {name: "LoansAdmin"},
                        module: "loan",
                        access: ['1-0', '2-1'],
                        action: () => {
                        },
                        children: [],
                    },
                ],
            },
            {
                id: generateRandomString(),
                name: "نرخ پست",
                icon: "clock",
                route: {name: "Deliveries"},
                module: "post_price",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "تخفیفات",
                icon: "box-arrow-up-right",
                route: {name: "Offer"},
                module: "offer_code",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "آدرس های پیش فرض",
                icon: "gear",
                route: {name: "DefaultAddresses"},
                module: "default_address",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "آمار",
                icon: "bar-chart",
                route: {name: "Statistic"},
                module: "statistic",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "فروشگاه ها",
                icon: "shop",
                route: {name: "MultipleStores"},
                module: "market_place",
                access: ['1-0'],
                action: () => {

                },
                children: [],
            },

        ]
    },


    {
        id: generateRandomString(),
        name: "مدیریت محتوا",
        icon: "text-paragraph",
        route: {},
        access: ['1-0', '2-1', '1-1', '1-2'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "دسته بندی",
                icon: "box-seam",
                route: {name: "Category"},
                module: "category",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "پست ها",
                icon: "bar-chart",
                route: {name: "PostsDashboard"},
                module: "post_and_page",
                access: ['1-0', '1-1', '1-2'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "برگه ها",
                icon: "bar-chart",
                route: {name: "PagesDashboard"},
                module: "post_and_page",
                access: ['1-0', '1-1', '1-2'],
                action: () => {
                },
                children: [],
            },


            {
                id: generateRandomString(),
                name: 'مدیریت فایل ها',
                icon: 'files',
                route: {name: 'FileManager'},
                access: ['1-0', '1-1'],
                module: 'file_manager',
                action: () => {
                },
                children: []
            },
            {
                id: generateRandomString(),
                name: "کامنت ها",
                icon: "chat-left-dots-fill",
                route: {name: "Comments"},
                module: "comment",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "تگ ها",
                icon: "chat-left-dots-fill",
                route: {name: "TagsDashboard"},
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
        ],
    },

    {
        id: generateRandomString(),
        name: "مدیریت LMS",
        icon: "journal",
        route: {},
        access: ['1-0', '2-1', '1-1', '1-2'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "محصولات",
                icon: "shop-window",
                route: {name: "ProductsDashboard"},
                module: "product",
                access: ['1-0', '2-1', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "دوره‌ها",
                icon: "collection-play-fill",
                route: {name: "CoursesDashboard"},
                module: "course_and_lesson",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "درس‌ها",
                icon: "collection-play-fill",
                route: {name: "LessonsDashboard"},
                module: "course_and_lesson",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "کاربران دوره",
                icon: "collection-play-fill",
                route: {name: "AddUserToProduct"},
                module: "course_and_lesson",
                access: ['1-0', '1-1'],
                action: () => {
                },
                children: [],
            },
        ]
    },


    {
        id: generateRandomString(),
        name: "فرم",
        icon: "ui-checks",
        route: {},
        access: [],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "فرم ها",
                icon: "bar-chart",
                route: {name: "Form"},
                module: "form_basic",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "فرم های پر شده من",
                icon: "bar-chart",
                route: {name: "CurrentUserFormFills"},
                module: "form_basic",
                access: [],
                action: () => {
                },
                children: [],
            },
        ],
    },

    {
        id: generateRandomString(),
        name: "چت",
        icon: "messenger",
        route: {},
        access: [],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "چت های من",
                icon: "messenger",
                route: {name: "UserChats"},
                access: [],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "همه چت ها",
                icon: "messenger",
                route: {name: "Chats"},
                module: "chat",
                access: ['1-0', '2-1'],
                action: () => {
                },
                children: [],
            },
        ],
    },
    {
        id: generateRandomString(),
        name: "مدیریت اشتراک",
        icon: "calendar-week",
        route: {},
        access: [],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "اشتراک های من",
                icon: "bar-chart",
                route: {name: "UserSubscription"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "لیست اشتراک ها",
                icon: "card-list",
                route: {name: "AllSubscription"},
                module: "subscription_product",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "لیست کاربران اشتراک",
                icon: "card-list",
                route: {name: "SubscriptionCharges"},
                module: "subscription_product",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
        ],
    },


    {
        id: generateRandomString(),
        name: "اتصال به سرویس خارجی",
        icon: "gear-wide-connected",
        route: {},
        access: [],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "ترب",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: [],
                module: 'torob',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "ایمالز",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0', '2-1', '1-3'],
                module: 'emalls',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "باسلام",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0', '2-1'],
                module: 'basalam',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "ذره بین",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0'],
                module: 'zarehbin',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "هلو",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0'],
                module: 'holoo',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "آسان",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0'],
                module: 'asan',
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "اسپات پلیر",
                icon: "bar-chart",
                route: {name: "LinkToolKid"},
                access: ['1-0'],
                module: 'spot_player',
                action: () => {
                },
                children: [],
            },
        ],
    },

    {
        id: generateRandomString(),
        name: "مدیریت تنظیمات",
        icon: "gear",
        route: {},
        access: ['1-0'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "تنظیمات",
                icon: "gear",
                route: {name: "SiteInfo"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "مدیریت منوها",
                icon: "list",
                route: {name: "MenuPanel"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "تنظیمات ارسال براساس مکان",
                icon: "list",
                route: {name: "DeliveryPriceBaseOnLocation"},
                module: "send_price_base_on_location",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "زمان بندی ها",
                icon: "clock",
                route: {name: "Timing"},
                module: "timing",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "زبان",
                icon: "person-fill",
                route: {name: "Languages"},
                module: "language",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "لینک های مفید",
                icon: "person-fill",
                route: {name: "LinkToolKid"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "اشتراک گذاری",
                icon: "box-arrow-up-right",
                route: {name: "Shares"},
                module: "share_module",
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "تنظیمات حسابداری",
                icon: "box-arrow-up-right",
                route: {name: "HolooConfig"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "لاگ",
                icon: "info-circle",
                route: {name: "Logs"},
                access: [],
                action: () => {

                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "رویدادها",
                icon: "info-circle",
                route: {name: "Events"},
                module: "event",
                access: [],
                action: () => {

                },
                children: [],
            },
        ],
    },
    {
        id: generateRandomString(),
        name: "پنل پیامک",
        icon: "chat-left-text-fill",
        route: {name: 'Sms'},
        access: ['1-0',],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "کاربران",
        icon: "person-fill",
        route: {name: "User"},
        module: "users",
        access: ['1-0'],
        action: () => {
        },
        children: [],
    },
];

export const UserDashboardMenu = [

    {
        id: generateRandomString(),
        name: "بازگشت به سایت",
        icon: "house",
        route: {name: "Home"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "داشبورد",
        icon: "bar-chart",
        route: {name: "Dashboard"},
        access: [],
        action: () => {
        },
        children: [],
    },

    {
        id: generateRandomString(),
        name: "پروفایل",
        icon: "person-fill",
        route: {name: "Profile"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "آدرس های من",
        icon: "signpost2-fill",
        route: {name: "Address"},
        access: [],
        action: () => {
        },
        children: [],
    },


    {
        id: generateRandomString(),
        name: "سفارش های من",
        icon: "cart-check",
        route: {name: "UserOrders"},
        access: [],
        action: () => {
        },
        children: [],
    },


    {
        id: generateRandomString(),
        name: "فرم های من",
        icon: "bar-chart",
        route: {name: "CurrentUserFormFills"},
        access: [],
        action: () => {
        },
        children: [],
    },


    {
        id: generateRandomString(),
        name: "چت های من",
        icon: "messenger",
        route: {name: "UserChats"},
        access: [],
        action: () => {
        },
        children: [],
    },


    {
        id: generateRandomString(),
        name: "اشتراک های من",
        icon: "bar-chart",
        route: {name: "UserSubscription"},
        access: ['1-0'],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "اقساط من",
        icon: "credit-card-fill",
        route: {name: "LoansUser"},
        access: [],
        action: () => {
        },
        children: [],
    },

]


export const storeDashboardMenu = [
    {
        id: generateRandomString(),
        name: "بازگشت به سایت",
        icon: "house",
        route: {name: "Home"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "داشبورد",
        icon: "bar-chart",
        route: {name: "Dashboard"},
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "پروفایل",
        icon: "person-fill",
        route: {name: "Profile"},
        module: '',
        access: [],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "محصولات",
        icon: "shop-window",
        route: {name: "ProductsDashboard"},
        module: 'product',
        access: ['1-0', '2-1'],
        action: () => {
        },
        children: [],
    },
    {
        id: generateRandomString(),
        name: "مدیریت محتوا",
        icon: "text-paragraph",
        route: {},
        access: ['1-0', '2-1', '1-1', '1-2'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "پست ها",
                icon: "bar-chart",
                route: {name: "PostsDashboard"},
                module: "post_and_page",
                access: ['1-0', '1-1', '1-2'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "برگه ها",
                icon: "bar-chart",
                route: {name: "PagesDashboard"},
                module: "post_and_page",
                access: ['1-0', '1-1', '1-2'],
                action: () => {
                },
                children: [],
            },
        ],
    },
    {
        id: generateRandomString(),
        name: "مدیریت تنظیمات",
        icon: "text-paragraph",
        route: {},
        access: ['1-0'],
        action: () => {
        },
        children: [
            {
                id: generateRandomString(),
                name: "تنظیمات",
                icon: "gear",
                route: {name: "SiteInfo"},
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
            {
                id: generateRandomString(),
                name: "مدیریت کاربران",
                icon: "person-fill",
                route: {name: "User"},
                module: 'users',
                access: ['1-0'],
                action: () => {
                },
                children: [],
            },
        ],
    },
];

export let dashboardRoutes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/dashboardTemplate',
        name: 'dashboardTemplate',
        component: DashboardTemplate,
        beforeEnter: multiguard([loginRequired]),
        children: [
            // one example for rest of the dashboard routes
            {
                path: '/user-access-denied',
                name: 'UserAccessDenied',
                components: {dashboard: UserAccessDenied},
            },
            {
                path: '/profile',
                name: 'Profile',
                components: {dashboard: Profile},
            },
            {
                path: '/address',
                name: 'Address',
                components: {dashboard: Address},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/address/create',
                name: 'CreateAddress',
                components: {dashboard: CreateAddress},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/address/update/:id',
                name: 'UpdateAddress',
                components: {dashboard: UpdateAddress},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user-address/:id',
                name: 'UserAddresses',
                components: {dashboard: Address},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/brand',
                name: 'Brand',
                components: {dashboard: Brand},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/brand/create',
                name: 'CreateBrand',
                components: {dashboard: CreateBrand},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/brand/edit/:slug',
                name: 'EditBrand',
                components: {dashboard: EditBrand},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/brand/trash',
                name: 'TrashBrand',
                components: {dashboard: TrashBrand},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/feature',
                name: 'Feature',
                components: {dashboard: Feature},
            },
            {
                path: '/feature/trash',
                name: 'TrashFeatures',
                components: {dashboard: TrashFeatures},
            },
            {
                path: '/feature/create',
                name: 'CreateFeature',
                components: {dashboard: CreateFeature},
            },
            {
                path: '/feature/update/:id',
                name: 'UpdateFeature',
                components: {dashboard: UpdateFeature},
            },
            {
                path: '/category',
                name: 'Category',
                components: {dashboard: Category},
            },
            {
                path: "/category/trash",
                name: "TrashCategory",
                components: {dashboard: TrashCategory},
            },
            {
                path: '/dashboard/product',
                name: 'ProductsDashboard',
                components: {dashboard: ProductsDashboard},
            },
            {
                path: '/site-info',
                name: 'SiteInfo',
                components: {dashboard: SiteInfo},
            },
            {
                path: '/site-info/create',
                name: 'CreateSiteInfo',
                components: {dashboard: CreateSiteInfo},
            },
            {
                path: '/site-info/update/:id',
                name: 'UpdateSiteInfo',
                components: {dashboard: UpdateSiteInfo},
            },
            {
                path: '/dashboard/product/create',
                name: 'CreateProduct',
                components: {dashboard: CreateProduct},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/product/edit/:slug',
                name: 'EditProduct',
                components: {dashboard: EditProduct},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/product/trash',
                name: 'TrashProduct',
                components: {dashboard: TrashProduct},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user',
                name: 'User',
                components: {dashboard: User},
            },
            {
                path: '/user/create',
                name: 'CreateUser',
                components: {dashboard: CreateUser},
            },
            {
                path: '/user/trash',
                name: 'TrashUser',
                components: {dashboard: TrashUser},
            },
            {
                path: '/user/update/:id',
                name: 'UpdateUser',
                components: {dashboard: UpdateUser},
            },
            {
                path: '/user/update/password/:id',
                name: 'UpdateUserPassword',
                components: {dashboard: ChangePassword},
            },
            {
                path: '/offer',
                name: 'Offer',
                components: {dashboard: Offer},
            },
            {
                path: '/offer/trash',
                name: 'TrashOffer',
                components: {dashboard: TrashOffer},
            },
            {
                path: '/offer/update/:id',
                name: 'UpdateOffer',
                components: {dashboard: UpdateOffer},
            },
            {
                path: '/offer/create',
                name: 'CreateOffer',
                components: {dashboard: CreateOffer},
            },
            {
                path: '/dashboard/user-orders',
                name: 'UserOrders',
                components: {dashboard: Orders},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/orders',
                name: 'Orders',
                components: {dashboard: AllOrders},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/orders/reservation',
                name: 'ReservationOrders',
                components: {dashboard: AllOrders},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/orders/create',
                name: 'CreateOrder',
                components: {dashboard: CreateOrder},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/orders/without-item',
                name: 'OrderWithoutItem',
                components: {dashboard: OrderWithoutItem},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/courses',
                name: 'CoursesDashboard',
                components: {dashboard: CoursesDashboard},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/courses/create',
                name: 'CreateCourse',
                components: {dashboard: CreateCourse},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/course/edit/:slug',
                name: 'EditCourse',
                components: {dashboard: EditCourse},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/courses/trash',
                name: 'TrashCourse',
                components: {dashboard: CourseTrash},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/lessons',
                name: 'LessonsDashboard',
                components: {dashboard: Lessons},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/create-lessons',
                name: 'CreateLessons',
                components: {dashboard: CreateContentLesson},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/update-lessons/:slug',
                name: 'UpdateLessons',
                components: {dashboard: UpdateContentLesson},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/create-content',
                name: 'CreateContent',
                components: {dashboard: CreateContent},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/update-content/:slug',
                name: 'UpdateContent',
                components: {dashboard: UpdateContent},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/posts',
                name: 'PostsDashboard',
                components: {dashboard: PostsListDashboard},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/pages',
                name: 'PagesDashboard',
                components: {dashboard: PagesListDashboard},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/contents/trash/:type',
                name: 'TrashContents',
                components: {dashboard: TrashContentList},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/file-manager',
                name: 'FileManager',
                components: {dashboard: FileManager},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/menu-panel',
                name: 'MenuPanel',
                components: {dashboard: Menus},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/edit-menu/:id',
                name: 'EditMenu',
                components: {dashboard: Menu},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/comments',
                name: 'Comments',
                components: {dashboard: Comments},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/timing',
                name: 'Timing',
                components: {dashboard: Timing},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/add-user-to-product',
                name: 'AddUserToProduct',
                components: {dashboard: AddUserToProduct},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/default/addresses',
                name: 'DefaultAddresses',
                components: {dashboard: Address},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/deliveries',
                name: 'Deliveries',
                components: {dashboard: Deliveries},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/deliveries/create',
                name: 'CreateDelivery',
                components: {dashboard: CreateDelivery},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/deliveries/update/:id',
                name: 'UpdateDelivery',
                components: {dashboard: UpdateDelivery},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/user/:user/wallets',
                name: 'UserWallets',
                components: {dashboard: ChargeWallet},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/loans/admin',
                name: 'LoansAdmin',
                components: {dashboard: LoansAdmin},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/loans/user',
                name: 'LoansUser',
                components: {dashboard: LoansUser},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/loan/items/user/:user/order/:order',
                name: 'LoanItems',
                components: {dashboard: LoanItems},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/languages',
                name: 'Languages',
                components: {dashboard: Languages},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/multiple-stores',
                name: 'MultipleStores',
                components: {dashboard: MultipleStores},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/chat',
                name: 'Chats',
                components: {dashboard: Chats},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/user/chats/user',
                name: 'UserChats',
                components: {dashboard: UserChats},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/statistic',
                name: 'Statistic',
                components: {dashboard: Statistic},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/link-tool-kit',
                name: 'LinkToolKid',
                components: {dashboard: LinkToolKit},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/tags',
                name: 'TagsDashboard',
                components: {dashboard: Tag},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/tags/create',
                name: 'TagCreate',
                components: {dashboard: CreateTag},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/tags/update/:id',
                name: 'TagUpdate',
                components: {dashboard: UpdateTag},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/tags/trash',
                name: 'TagTrash',
                components: {dashboard: TrashTag},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/chat/create',
                name: 'ChatCreate',
                components: {dashboard: ChatCreate},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/dashboard/orders/update/:id',
                name: 'updateOrder',
                components: {dashboard: CreateOrder},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/product/basalam/config/:slug',
                name: 'productBasalamSetting',
                components: {dashboard: ProductBasalamSetting},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/sms',
                name: 'Sms',
                components: {dashboard: Sms},
                beforeEnter: multiguard([needPhoneVerification]),

            },
            {
                path: '/dashboard/sms/send',
                name: 'SendSms',
                components: {dashboard: SendSms},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/sms/send/with-template',
                name: 'SendSmsWithTemplate',
                components: {dashboard: SendSmsWithTemplate},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/wishlist/:user_id',
                name: 'DashboardWishList',
                components: {dashboard: WishList},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/subscription/:user',
                name: 'Subscription',
                components: {dashboard: Subscription},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user-subscription',
                name: 'UserSubscription',
                components: {dashboard: UserSubscription},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/form',
                name: 'Form',
                components: {dashboard: Form},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/form/create',
                name: 'FormCreate',
                components: {dashboard: CreateForm},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/form/update/:id',
                name: 'FormUpdate',
                components: {dashboard: UpdateForm},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/form/:id/fills',
                name: 'FormFills',
                components: {dashboard: FormFills},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user/:user/form-fill/:form_fill',
                name: 'FormAnswer',
                components: {dashboard: FormAnswer},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user/form-fills',
                name: 'CurrentUserFormFills',
                components: {dashboard: CurrentUserFormFills},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/user/:user/form-fills',
                name: 'UserFormFills',
                components: {dashboard: UserFormFills},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/print/form/:form/product/:product',
                name: 'PrintCourseForm',
                components: {dashboard: PrintCourseForm},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/logs',
                name: 'Logs',
                components: {dashboard: Logs},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/all-subscription',
                name: 'AllSubscription',
                components: {dashboard: AllSubscription},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/creat-subscription',
                name: 'CreatSubscription',
                components: {dashboard: CreatSubscription},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/update-subscription/:id',
                name: 'UpdateSubscription',
                components: {dashboard: UpdateSubscription},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/events',
                name: 'Events',
                components: {dashboard: Event},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/events/create',
                name: 'EventCreate',
                components: {dashboard: CreateEvent},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/events/update/:id',
                name: 'EventUpdate',
                components: {dashboard: UpdateEvent},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/shares',
                name: 'Shares',
                components: {dashboard: Share},
                beforeEnter: multiguard([]),
            },
            {
                path: '/dashboard/subscription-charges',
                name: 'SubscriptionCharges',
                components: {dashboard: SubscriptionCharge},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/subscription-charges-filter',
                name: 'SubscriptionChargesFilter',
                components: {dashboard: SubscriptionChargeFilter},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/delivery-price-base-on-location',
                name: 'DeliveryPriceBaseOnLocation',
                components: {dashboard: DeliveryPriceBaseOnLocation},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/holoo-config',
                name: 'HolooConfig',
                components: {dashboard: Dashboard},
                beforeEnter: multiguard([needPhoneVerification]),
            },
            {
                path: '/dashboard/my-course',
                name: 'mycourse',
                components: {dashboard: UserCourse},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/dashboard/modules',
                name: 'ModulesList',
                components: {dashboard: ModulesList},
                beforeEnter: multiguard([loginRequired]),
            },
            {
                path: '/module-install',
                name: 'ModuleInstall',
                components: {dashboard: ModuleInstall},
                beforeEnter: multiguard([loginRequired]),
            },
        ]
    },
    {
        path: '/store-dashboard',
        name: 'StoreDashboard',
        component: StoreDashboard,
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/storeDashboardTemplate',
        name: 'storeDashboardTemplate',
        component: StoreDashboardTemplate,
        beforeEnter: multiguard([loginRequired]),
        children: [
            {
                path: '/store-dashboard/products',
                name: 'StoreDashboardProducts',
                components: {dashboard: TableProduct},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },
            {
                path: '/store-dashboard/product/create',
                name: 'CreateStoreProduct',
                components: {dashboard: CreateStoreProduct},
                beforeEnter: multiguard([loginRequired, needPhoneVerification]),
            },

        ]
    },
]

export const dashboardRoutesBaseOnAccess = () => {
    let isAdmin = store.getters['User/isAdmin']
    let isStore = store.getters['User/isUserStore']

    if (isAdmin) {
        return dashboardMenu
    }

    if (isStore) {
        return storeDashboardMenu
    }

    return UserDashboardMenu
}
